import * as angular from "angular";
import {LayoutWindow, LayoutUser} from "../models/layout-window.model";
import {UserSessionService} from "../services/user-session/user-session.service";
import {Nav} from "../models/app-config.model";

export interface LayoutInitService { (): void; }

/* @ngInject */
export function layoutInitService(
    $window: angular.IWindowService, userSessionService: UserSessionService, NAV: Nav
): LayoutInitService {
    // This is a temporary fix until the backend supports populating the navbar
    const navItems = [{ url: `${NAV.baseUrl}${NAV.homeUrl}` }];

    const setupNav = [
        { url: `${NAV.baseUrl}${NAV.accountUrl}`, text: "My Account" },
        { url: `${NAV.baseUrl}${NAV.setupUrl}`, text: "Setup" },
        { url: `${NAV.switchProfileUrl}`, text: "Switch Profile" },
        { url: `${NAV.baseUrl}${NAV.logoutUrl}`, text: "Logout" }
    ];

    const setupHelp = {
        secondary: {
            name: "Reach Out",
            items: [
                { url: `${NAV.baseUrl}${NAV.suggestANewFeatureUrl}`, text: "Suggest a New Feature" }
            ]
        }
    };

    return (() => {
        const layoutUser: LayoutUser = userSessionService.getLayoutUser();
        if (layoutUser) {
            ($window as LayoutWindow).succeedLayout.showUserInfo(layoutUser);
        }

        ($window as LayoutWindow).succeedLayout.createNav(navItems, setupNav, setupHelp, null);
        ($window as LayoutWindow).succeedLayout.applyToggles({
            "ops.terms_of_service.show_new": false,
            "ops.privacy_policy.show_new": Date.now() <= new Date("2020-01-19").getTime(),
        });
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/layout-init/layout-init.service.ts